import { useEffect } from "react";
import * as THREE from 'three';
import {useEditorStore} from "../../../stores";
import { useAxesAlignmentStore } from "../../../stores";
import { useShallow } from "zustand/shallow";
import { landmarksConfig } from "../../tools/PinToolCard";

const AxesHandler = () => {

    const [scene, camera, renderer, shadedMesh] = useEditorStore(
        useShallow(s => [
            s.sceneRefs.scene,
            s.sceneRefs.camera,
            s.sceneRefs.renderer,
            s.sceneRefs.shadedMesh,
        ]
    ));

    const [activeKey, savePoint, selections, setAlignmentStatus ] = useAxesAlignmentStore(
        useShallow((state) => [ state.activeKey, state.savePoint, state.selections, state.setAlignmentStatus ])
    );

    const sphereSize = 0.5;

    useEffect(() => {
        if (!selections || selections.length === 0) return;
        for (const key in selections) {
            if (selections.hasOwnProperty(key)) {
                const { sphere } = selections[key];
                if (sphere) {
                    sphere.visible = true;
                }
            }
        }

        return (() => {
            for (const key in selections) {
                if (selections.hasOwnProperty(key)) {
                    const { sphere } = selections[key];
                    if (sphere) {
                        sphere.visible = false;
                    }
                }
            }
        });
    }, [selections]);

    useEffect(() => {
        if (!scene || !camera || !renderer || !shadedMesh) return

        const raycaster = new THREE.Raycaster()
        const mouse = new THREE.Vector2()

        const getColorById = id => {
            const cfg = landmarksConfig.find(l => l.id === id)
            return cfg.color
        }

        const onPointerDown = (e) => {
            if (!activeKey) return

            const rect = renderer.domElement.getBoundingClientRect()
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1

            raycaster.setFromCamera(mouse, camera)
            const hits = raycaster.intersectObject(shadedMesh, true)
            if (hits.length > 0) {
                const { point } = hits[0]
                const sphereGeo = new THREE.SphereGeometry(sphereSize, 16, 16)
                const c = getColorById(activeKey)
                const sphereMat = new THREE.MeshBasicMaterial({ color: c })
                const sphere = new THREE.Mesh(sphereGeo, sphereMat)
                sphere.position.copy(point)
                shadedMesh.add(sphere)

                savePoint(activeKey, sphere)
                setAlignmentStatus(false)
            }
        }

        renderer.domElement.addEventListener('pointerdown', onPointerDown)
        return () => {
            renderer.domElement.removeEventListener('pointerdown', onPointerDown)
        }
    }, [scene, camera, renderer, shadedMesh, activeKey, savePoint]);

    return null;
};
export default AxesHandler;